export default __webpack_public_path__ + "static/media/expense-employee-management.5f637233.svg";